export const mqSmallOnly = "screen and ( max-width: 31.1875em )";
export const mqMediumAndUp = "screen and ( min-width: 31.25em )";
export const mqMediumOnly = "screen and ( min-width: 31.25em ) and ( max-width: 48.75em )";
export const mqMediumAndBelow = "screen and ( max-width: 48.6875em )";
export const mqZeroToLarge = "screen and ( min-width: 0 ) and ( max-width: 48.6875em )";
export const mqLargeAndUp = "screen and ( min-width: 48.75em )";
export const mqLargeAndBelow = "screen and ( max-width: 87.4375em )";
export const mqXlargeAndUp = "screen and ( min-width: 87.5em )";